export const USER_CONNECTED = 'USER_CONNECTED';

export const userConnected = payload => dispatch =>
  dispatch({
    type: USER_CONNECTED,
    payload,
  });
